import React from 'react';

interface ErrorBoundaryState {
  error: Error | null;
}

// Nothing in this app previously caught a render error, so a single thrown
// exception anywhere in the tree unmounted everything and left a blank
// page with no way to tell what broke. This shows the real error instead
// of guessing at a friendly message -- there's no way to know what failed
// ahead of time, so a generic "something went wrong" would hide the one
// piece of information that actually helps.
export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24, background: '#0B0B12', color: '#F2F2F7', fontFamily: 'Public Sans, ui-sans-serif, system-ui, sans-serif', textAlign: 'center' }}>
          <h1 style={{ margin: 0, fontSize: 20 }}>OZIRA hit an error and couldn't continue.</h1>
          <pre style={{ maxWidth: '90vw', overflow: 'auto', padding: 12, borderRadius: 8, background: '#1C1C28', color: '#E5484D', fontSize: 13, textAlign: 'start' }}>{this.state.error.message}</pre>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ padding: '10px 20px', border: 'none', borderRadius: 999, background: '#DB141A', color: '#fff', font: 'inherit', fontWeight: 600, cursor: 'pointer' }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
